import * as type from "../../types/API/documents";

export function getDocuments(payload: any) {
  return {
    type: type.GET_DOCUMENTS,
    payload: payload,
  };
}

export function getTableDocuments(payload: any) {
  return {
    type: type.GET_TABLE_DOCUMENTS,
    payload: payload,
  };
}

export function createDocument(payload: any) {
  return {
    type: type.CREATE_DOCUMENT,
    payload: payload,
  };
}

export function getDocumentById(payload: any) {
  return {
    type: type.GET_DOCUMENTS_BY_ID,
    payload: payload,
  };
}

export function getApprovalHistory(payload: any) {
  return {
    type: type.GET_APPROVAL_HISTORY,
    payload: payload,
  };
}

export function changeApprovalStatus(payload: any) {
  return {
    type: type.CHANGE_APPROVAL_STATUS,
    payload: payload,
  };
}


export function getDocumentsByStatus(payload: any) {
  return {
    type: type.GET_DOCUMENTS_BY_STATUS,
    payload: payload,
  };
}

export function editDocument(payload: any) {
  return {
    type: type.EDIT_DOCUMENT,
    payload: payload,
  };
}

export function discardDocument(payload: any) {
  return {
    type: type.DISCARD_DOCUMENT,
    payload: payload,
  };
}

export function deleteDocument(payload: any) {
  return {
    type: type.DELETE_DOCUMENT,
    payload: payload,
  };
}

export function previewDocument(payload: any) {
  return {
    type: type.PREVIEW_DOCUMENT,
    payload: payload,
  };
}

export function getDocumentItems(payload: any) {
  return {
      type: type.GET_DOCUMENT_ITEMS,
      payload: payload
  }
}

export function shortCloseTransaction(payload: any) {
  return {
      type: type.SHORT_CLOSE_TRANSACTION,
      payload: payload
  }
}

export function getSalesDocumentsItems(payload: any) {
  return {
      type: type.GET_SALES_DOCUMENTS_ITEMS,
      payload: payload
  }
}

export function getServiceChallanItems(payload: any) {
  return {
      type: type.GET_SERVICE_CHALLAN_ITEMS,
      payload: payload
  }
}

export function createEInvoice(payload: any) {
  return {
      type: type.CREATE_EINVOICE,
      payload: payload
  }
}

export function createEWayBill(payload: any) {
  return {
      type: type.CREATE_EWAYBILL,
      payload: payload
  }
}

export function fetchCurrentDoc(payload: any) {
  return {
      type: type.FETCH_CURRENT_DOC,
      payload: payload
  }
}

export function emailDocument(payload: any) {
  return {
      type: type.EMAIL_DOCUMENT,
      payload: payload
  }
}

export function cancelEInvoice(payload: any) {
  return {
      type: type.CANCEL_EINVOICE,
      payload: payload
  }
}

export function getChallanItems(payload: any) {
  return {
      type: type.GET_CHALLAN_ITEMS,
      payload: payload
  }
}

export function createEWayBillFromEInvoice(payload: any) {
  return {
      type: type.CREATE_EWAYBILL_FROM_EINVOICE,
      payload: payload
  }
}

export function cancelEWayBill(payload: any) {
  return {
    type: type.CANCEL_EWAYBILL,
    payload: payload,
  };
}

export function saveRfqQuotation(payload: any) {
  return {
    type: type.SAVE_RFQ_QUOTATION,
    payload: payload,
  };
}